<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="time"
    max-width="290px"
    min-width="290px"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field :value="value" readonly v-bind="attrs" v-on="on"></v-text-field>
    </template>

    <input-card
      @save="save"
      @cancel="cancel"
      :is-save-disabled="false"
      v-click-outside="{
        handler: onClickOutside,
        include,
        closeConditional,
      }"
    >
      <v-time-picker v-model="time" v-if="menu" format="ampm" ampm-in-title full-width scrollable></v-time-picker>
    </input-card>
  </v-menu>
</template>

<script>
import InputCard from '@/components/InputCard';
import inputCard from '@/mixins/inputCard';

export default {
  name: 'CustomTimeInput',
  mixins: [inputCard],
  components: {
    InputCard,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    menu: false,
    time: null,
  }),
  methods: {
    setValue() {
      this.$emit('input', this.time);
      this.menu = false;
    },
    getValue() {
      return this.time;
    },
  },
};
</script>

<style lang="scss" scoped>
.v-input {
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: center;
}
.v-picker {
  border-radius: 0px;
}
::v-deep .v-input__slot {
  margin-bottom: 3px;
  input {
    padding: 0px;
  }
  label {
    top: 0px;
  }
}
</style>
